import React from 'react';
import Textfield from '@atlaskit/textfield';
import SearchIcon from '@atlaskit/icon/glyph/search';
import CrossCircleIcon from '@atlaskit/icon/glyph/cross-circle';
import isEmpty from 'lodash/isEmpty';
import Button from '@atlaskit/button';
import { N90 } from '@atlaskit/theme/colors';
import { ErrorMessage, HelperMessage } from '@atlaskit/form';
import { Box } from '@atlaskit/primitives';
import Spinner from '@atlaskit/spinner';
import { SearchIconWrapper } from './search-field.styles';

export const SearchField = ({
  searchQuery,
  placeholder,
  onQueryChange,
  clearSearchQuery,
  isDisabled = false,
  showSearchIconBeforeInput = false,
  errorMessage,
  searchSubText,
  showSearchSubtext = false,
  isLoading = false,
}: {
  searchQuery?: string;
  placeholder?: string;
  isDisabled?: boolean;
  onQueryChange: (_searchQuery: string) => void;
  clearSearchQuery: () => void;
  showSearchIconBeforeInput?: boolean;
  errorMessage?: string;
  searchSubText?: string;
  showSearchSubtext?: boolean;
  isLoading?: boolean;
}) => {
  const getElementAfterInput = () => {
    if (isEmpty(searchQuery)) {
      return !showSearchIconBeforeInput && <SearchIcon label="search" testId="search-icon" />;
    }

    if (isLoading) {
      return (
        <Box paddingInline="space.150" testId="search-field-spinner">
          <Spinner />
        </Box>
      );
    }

    return (
      <Button
        iconAfter={<CrossCircleIcon label="clear" />}
        onClick={() => clearSearchQuery()}
        appearance="subtle"
        testId="clear-icon"
      />
    );
  };

  return (
    <>
      <Textfield
        elemAfterInput={getElementAfterInput()}
        elemBeforeInput={
          showSearchIconBeforeInput && (
            <SearchIconWrapper>
              <SearchIcon primaryColor={N90} label="search" size="small" />
            </SearchIconWrapper>
          )
        }
        value={searchQuery ?? ''}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onQueryChange(e.target.value)}
        isDisabled={isDisabled}
        placeholder={placeholder}
        testId="search-field"
      />
      {showSearchSubtext && <HelperMessage>{searchSubText}</HelperMessage>}
      {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
    </>
  );
};
